function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import cn from 'classnames';
import { icons, IconNameMedium, IconNameSmall } from './icons';
require("./Icon.css");
var styles = {
  "Root": "Icon-module-Root_1g8"
};
export const IconGradientNames = {
  caribbeanSea: 'caribbeanSea',
  callicarpa: 'callicarpa'
};
const sizeMap = {
  m: 24,
  s: 16
};
export const Icon = ({
  className,
  gradientName,
  name,
  size = 'm',
  ...props
}) => {
  const icon = icons[size];
  if (!name || !icon[name]) return null;
  const width = icon[name]?.width || sizeMap[size];
  const height = icon[name]?.height || sizeMap[size];
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: cn(styles.Root, className),
    focusable: false,
    width: width,
    height: height,
    viewBox: `0 0 ${width} ${height}`
  }, props), name === 'ukassa' && /*#__PURE__*/React.createElement("rect", {
    width: width,
    height: height,
    rx: "0",
    fill: "url(#ukassa-gradient)"
  }), icon[name].paths.map(({
    path,
    fill,
    fillRule,
    stroke,
    clipRule
  }) => /*#__PURE__*/React.createElement("path", _extends({
    key: path,
    d: path
  }, stroke && {
    stroke
  }, fill && {
    fill
  }, fillRule && {
    fillRule
  }, clipRule && {
    clipRule
  }, gradientName && !fill && {
    fill: 'url(#icon-gradient)'
  }))), gradientName === 'caribbeanSea' && /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-gradient",
    x1: "6.61864",
    y1: "16.83",
    x2: "14.3041",
    y2: "2.03944",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8168F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.137",
    stopColor: "#7F6DF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.2924",
    stopColor: "#787AF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.4568",
    stopColor: "#6C91F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.6273",
    stopColor: "#5DB1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.8012",
    stopColor: "#48D9F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.8195",
    stopColor: "#46DEF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#50E3C2"
  }))), gradientName === 'callicarpa' && /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-gradient",
    gradientUnits: "userSpaceOnUse",
    x1: "3.1897",
    y1: "3.8409",
    x2: "21.2006",
    y2: "21.7706"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#FF00D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.9906",
    stopColor: "#3AA8F2"
  }))), name === 'bnpl' && /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bnpl-gradient-1",
    x1: "-8.39574e-08",
    y1: "28.1852",
    x2: "31.2573",
    y2: "18.928",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8EC4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.567624",
    stopColor: "#4DE544"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#49C8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bnpl-gradient-2",
    x1: "28.3239",
    y1: "4.74891e-06",
    x2: "19.5638",
    y2: "14.3299",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDEFFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#91E5CB"
  }))), name === 'ukassa' && /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ukassa-gradient",
    x1: "20",
    y1: "0",
    x2: "20",
    y2: "40",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0160D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#00479C"
  }))));
};